import {Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, Typography, withStyles, WithStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as FamilyActions from '@services/family/family.actions';
import * as React from 'react';

import TranslateNew from '@translate/TranslateNew';
import { connect } from 'react-redux';
import { IFamilyData, IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyStyle } from './update-family-member/Family.style';
import * as UserActions from '@services/user/user.actions';
const tn :TranslateNew = TranslateNew.getInstance();

interface IProps  extends WithStyles<typeof FamilyStyle> {
  isOpen: boolean;
  country:string|undefined;
  myName:string;
  onClose: (disableAnotherFamily:boolean) => void;
  createFamily: (familyName:IFamilyData) => void;
  reportProblem: (msg:string) => void;
}

interface IState {
  familyName: string;
  separated:boolean;
}

class NewFamilyDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      familyName:"",
      separated:true,
    };
  }
  public render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={() => this.props.onClose(false)}
        style={{minWidth:300}}
      >
          <DialogTitle>
            {tn.lang.createNewFamily}
          </DialogTitle>
          <DialogContent style={{display: 'flex', flexDirection: 'column', gap:'24px'}}>
            <Typography>
              {tn.lang.createNewFamilyInfo}
            </Typography>
            <Typography>
              {tn.lang.createNewFamilyInfo1}
            </Typography>
            <FormControlLabel 
              onClick={(event:any) => this.setState({separated:!this.state.separated})}
              control={<Switch color="primary" checked={(this.state.separated)}/>} 
              label={tn.lang.seperated} />
          </DialogContent>
          <DialogActions style={{ padding: '24px 16px', gap: '16px'}}>
            <Button onClick={() => this.props.onClose(false)}>{tn.lang.cancel}</Button>
            <Button 
              variant='contained' color='primary'
              onClick={() => {this.createFamily()}}>
                {tn.lang.createNewFamily}
            </Button>
          </DialogActions>
      </Dialog>
    );
  }

  private createFamily() {

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let familyType:"SEPARATED" | "TOGETHER" = "SEPARATED";
    if (this.state.separated === false) {
      familyType = "TOGETHER";
    }

    const familyData:IFamilyData = {
      id:0,
      name: tn.lang.newGroup+" "+this.props.myName,
      country:this.props.country || "US",
      timezone:timeZone,
      familyType,
    } 

    this.props.createFamily(familyData); 
    // this.props.reportProblem("Created another family: "+this.props.myName);
    this.props.onClose(true);
  }
}

function mapStateToProps(state: any) {
  const country:string|undefined = state.user.session.data.country;

  let myName:string = "new group"
  const userId:number = state.user.session.data.id;
  const family:IFamilyMember[] = state.family.family;
  const me = family.find((mem) => mem.id === userId);
  if (me) {myName = me.firstName}

  return {
    myName,
    country,
  };
}

const mapDispatchToProps = {
  createFamily: FamilyActions.createFamily,
  reportProblem: UserActions.reportProblem,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(FamilyStyle)(NewFamilyDialog));



// WEBPACK FOOTER //
// ./src/components/extended-family/NewFamilyDialog.tsx